/**
 * File: fomo-tracker.js
 * Purpose: Track clicks on deal buttons and send to FOMO service via Beacon API.
 */

(function () {
  'use strict';

  const getEndpoint = () => {
    if (window.bfwtVars && window.bfwtVars.restUrl) {
      return window.bfwtVars.restUrl + 'app-api/v1/fomo/track';
    }
    return '/wp-json/app-api/v1/fomo/track';
  };

  const FOMO_CONFIG = {
    endpoint: getEndpoint(),
    debug: new URLSearchParams(window.location.search).has('bf_fomo_debug'),
  };

  let lastBrandId = null;
  let lastClickTs = 0;

  function log(msg, data) {
    if (FOMO_CONFIG.debug) {
      console.log('[FOMO Tracker] ' + msg, data || '');
    }
  }

  function trackClick(e) {
    const link = e.target.closest('a, button');
    if (!link) {
      return;
    }

    const card = link.closest('.bfwt-deal-card');
    if (!card) {
      return;
    }

    const inner = card.querySelector('.bfwt-deal-row-inner');
    if (!inner) {
      return;
    }

    const brandId = inner.dataset.brand_id;
    const dealId = inner.dataset.dealid;

    if (!brandId || brandId === '0') {
      log('Click detected but no Brand ID found on card.', { card, inner });
      return;
    }

    // Cooldown: prevent double-firing when Copy Code + Visit Store trigger back-to-back
    const now = Date.now();
    if (brandId === lastBrandId && now - lastClickTs < 3000) {
      return;
    }
    lastBrandId = brandId;
    lastClickTs = now;

    const hasPromo = !!(inner.dataset.promo && inner.dataset.promo.trim());

    const payload = {
      brand_id: brandId,
      event_type: 'click',
      meta: {
        deal_id: dealId,
        brand_name:
          inner.dataset.brandName || inner.dataset['brand-name'] || '',
        deal_type: hasPromo ? 'code' : 'deal',
        source: 'web',
      },
    };

    if (typeof window.dataLayer === 'object' && window.dataLayer !== null) {
      const source = card.closest('.bfwt-fomo-footer, .bfwt-fomo-list')
        ? 'fomo_ticker'
        : 'deal_card';
      window.dataLayer.push({
        event: 'fomo_deal_click',
        brand_id: brandId,
        deal_id: dealId || '',
        source: source,
        event_category: 'bf_deals',
      });
    }

    if (navigator.sendBeacon) {
      const blob = new Blob([JSON.stringify(payload)], {
        type: 'application/json',
      });
      const sent = navigator.sendBeacon(FOMO_CONFIG.endpoint, blob);
      log('Beacon sent status:', sent);
    } else {
      fetch(FOMO_CONFIG.endpoint, {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: { 'Content-Type': 'application/json' },
        keepalive: true,
      }).then((r) => log('Fetch sent', r));
    }
  }

  document.addEventListener('click', trackClick, { passive: true });
})();
